module.exports = __webpack_public_path__ + "img/img33.4051f3f2.svg";